interface WaterfallChartProps {
  items: { label: string; value: number; type: 'add' | 'subtract' | 'total' }[];
  height?: number;
  currency?: string;
}

export default function WaterfallChart({ items, height = 220, currency = 'MVR' }: WaterfallChartProps) {
  const values: number[] = [];
  let running = 0;
  for (const item of items) {
    if (item.type === 'total') {
      values.push(running);
    } else {
      values.push(running);
      running += item.type === 'add' ? item.value : -item.value;
    }
  }

  const allValues: number[] = [];
  running = 0;
  for (const item of items) {
    if (item.type === 'total') {
      allValues.push(running);
    } else {
      allValues.push(running);
      running += item.type === 'add' ? item.value : -item.value;
      allValues.push(running);
    }
  }
  allValues.push(running);

  const maxVal = Math.max(...allValues.map(Math.abs), 1);
  const chartPadding = 50;
  const barWidth = 64;
  const gap = 16;
  const totalWidth = items.length * (barWidth + gap) + chartPadding * 2;
  const baseline = height * 0.6;

  function valueToY(val: number) {
    return baseline - (val / maxVal) * (height * 0.5);
  }

  let cumulative = 0;

  return (
    <div className="w-full overflow-x-auto">
      <svg width={Math.max(totalWidth, 400)} height={height + 70} viewBox={`0 0 ${Math.max(totalWidth, 400)} ${height + 70}`} className="mx-auto">
        <line x1={chartPadding - 10} y1={baseline} x2={Math.max(totalWidth, 400) - 10} y2={baseline} stroke="rgba(255,255,255,0.15)" strokeWidth="1" />

        {items.map((item, i) => {
          const x = chartPadding + i * (barWidth + gap);
          let barStart: number, barEnd: number;

          if (item.type === 'total') {
            barStart = 0;
            barEnd = cumulative;
          } else if (item.type === 'add') {
            barStart = cumulative;
            barEnd = cumulative + item.value;
            cumulative += item.value;
          } else {
            barEnd = cumulative;
            barStart = cumulative - item.value;
            cumulative -= item.value;
          }

          const y1 = valueToY(Math.max(barStart, barEnd));
          const y2 = valueToY(Math.min(barStart, barEnd));
          const barHeight = Math.max(y2 - y1, 2);

          const color = item.type === 'total'
            ? (cumulative >= 0 ? '#0d9488' : '#ef4444')
            : item.type === 'add' ? '#10b981' : '#ef4444';

          const connectorX = x + barWidth;
          const connectorEndX = x + barWidth + gap;
          const connectorY = item.type === 'add' ? valueToY(barEnd) : valueToY(barStart);

          return (
            <g key={i}>
              <rect x={x} y={y1} width={barWidth} height={barHeight} rx={4} fill={color} opacity={0.85} />
              <text x={x + barWidth / 2} y={y1 - 8} textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="11" fontWeight="600">
                {item.type === 'subtract' ? '-' : ''}{currency} {item.value.toFixed(0)}
              </text>
              <text x={x + barWidth / 2} y={height + 20} textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10">
                {item.label}
              </text>
              {i < items.length - 1 && item.type !== 'total' && (
                <line x1={connectorX} y1={connectorY} x2={connectorEndX} y2={connectorY} stroke="rgba(255,255,255,0.5)" strokeWidth="1" strokeDasharray="3" />
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
}
